//prettier-ignore
export const MapKindToSliceName = {
  ADDomainController: 'adDomainControllers',
  Account         : 'accountList',
  AppRole         : 'appRolesList',
  Application     : 'applicationList',
  ApplicationMCP  : 'applicationList',
  ApprovalReq     : 'approvalReqList',
  AwsResource     : 'awsResources',
  AzureResource   : 'azureResources',
  Database        : 'databases',
  GcpResource     : 'gcpResources',
  GitServer       : 'serverList',
  GithubResource  : 'githubResources',
  GithubAccount   : 'githubAccount',
  // Backend kind names since the scm_account/scm_resource rename.
  ScmResource     : 'githubResources',
  ScmAccount      : 'githubAccount',
  Group           : 'groupList',
  IamAction       : 'iamActions',
  KubeNamespace   : 'kubeNamespaces',
  Kafka           : 'kafkas',
  Org             : 'orgs',
  PacPolicy       : 'policyList',
  PaaPolicy       : 'paaPolicyList',
  Project         : 'projects',
  ProxyController : 'proxycontrollers',
  Server          : 'serverList',
  ServerController: 'serverControllers',
  ServiceAccount  : 'serviceAccounts',
  ServiceNowTable : 'servicenowtables',
  TagPolicy       : 'tagPolicys',
  TenantProfile   : 'tenantprofiles',
  TenantSiemConfig: 'tenantsiemconfigs',
  RDPServer       : 'rdpServers',
  GSuite          : 'gsuiteList',
  User            : 'userList',
  SlackChannel    : 'slackChannelList',
  JiraProject     : 'jiraProjectList',
  MsTeamsIntegration: 'msTeamsIntegrations',
  MattermostIntegration: 'mattermostIntegrations',
  SlackIntegration: 'slackIntegrationList',
  Approvers       : 'approvers',
  MedusaNode      : 'medusaNodes',
  WorkloadIdentity: 'workloads',
  KubeCluster     : 'kubeClusters',
  NotificationSubscription: 'notificationsubscriptions',
  ReqBundle: 'bundles',
  rdppasswords: 'rdppasswords',
  //!TODO Remove these non-kind keys
  SalesForceUsersList: 'salesForceUsersList',
  SalesForcePermissionList: 'salesForcePermissionList',
  SalesForceAccountList: 'salesForceAccountList',
  SalesForceUserPermissionBinding: 'salesForceUserPermissionBinding',
  SalesforceUser: 'salesForceUsersList',
  CRMEntity: 'salesForcePermissionList',
  SnowflakeRole: 'snowFlakeRoles',
  SalesforceAccount: 'salesForceAccountList',
  DatabricksResource: 'dataBricksResources',
  PrivateAccount: 'privateAccounts',
  SecretStoreAccount: 'secretStoreAccounts',
  Secret: 'secrets',
  SecretTemplate: 'secretTemplates',
  CloudAgent    : 'cloudagents',
  AIAgentAccount: 'aiagentaccounts',
  AgentAccessKey: 'agentAccessKeys',
  AIPolicy: 'aiPolicyList',
  AIIntent: 'aiIntentList',
  AgentApproval: 'agentApprovalList',
  AgentKeyUsage : 'agentKeyUsage',
  UserVault     : 'uservaults',
  ShadowAIPolicy: 'shadowAIPolicyList',
  NonHumanIdentity: 'nonHumanIdentityList',
  AccessGrant   : 'accessGrants'
}

export const MapSliceNameToKind = {
  adDomainControllers: 'ADDomainController',
  accountList: 'Account',
  appRolesList: 'AppRole',
  applicationList: 'Application',
  approvalReqList: 'ApprovalReq',
  awsResources: 'AwsResource',
  azureResources: 'AzureResource',
  databases: 'Database',
  gcpResources: 'GcpResource',
  githubResources: 'GithubResource',
  githubAccount: 'GithubAccount',
  scmresources: 'ScmResource',
  'scm-account': 'ScmAccount',
  groupList: 'Group',
  iamActions: 'IamAction',
  kubeNamespaces: 'KubeNamespace',
  kafkas: 'Kafka',
  orgs: 'Org',
  policyList: 'PacPolicy',
  paaPolicyList: 'PaaPolicy',
  proxyControllers: 'ProxyController',
  projects: 'Project',
  serverList: 'Server',
  serverControllers: 'ServerController',
  serviceAccounts: 'ServiceAccount',
  servicenowtables: 'ServiceNowTable',
  tagPolicys: 'TagPolicy',
  tenantprofiles: 'TenantProfile',
  tenantsiemconfigs: 'TenantSiemConfig',
  rdpServers: 'RDPServer',
  gsuiteList: 'GSuite',
  userList: 'User',
  slackChannelList: 'SlackChannel',
  jiraProjectList: 'JiraProject',
  approvers: 'Approvers',
  medusaNodes: 'MedusaNode',
  workloads: 'WorkloadIdentity',
  kubeClusters: 'KubeCluster',
  notificationsubscriptions: 'NotificationSubscription',
  bundles: 'ReqBundle',
  rdppasswords: 'rdppasswords',
  salesForceUsersList: 'SalesforceUser',
  salesForcePermissionList: 'CRMEntity',
  salesForceAccountList: 'SalesforceAccount',
  salesForceUserPermissionBinding: 'SalesForceUserPermissionBinding',
  snowFlakeRoles: 'SnowflakeRole',
  dataBricksResources: 'DatabricksResource',
  privateAccounts: 'PrivateAccount',
  msTeamsIntegrations: 'MsTeamsIntegration',
  mattermostIntegrations: 'MattermostIntegration',
  slackIntegrationList: 'SlackIntegration',
  secretStoreAccounts: 'SecretStoreAccount',
  secrets: 'Secret',
  secretTemplates : 'SecretTemplate',
  cloudagents     : 'CloudAgent',
  aiagentaccounts : 'AIAgentAccount',
  agentAccessKeys : 'AgentAccessKey',
  aiPolicyList : 'AIPolicy',
  aiIntentList : 'AIIntent',
  agentApprovalList : 'AgentApproval',
  agentKeyUsage   : 'AgentKeyUsage',
  uservaults      : 'UserVault',
  shadowAIPolicyList: 'ShadowAIPolicy',
  nonHumanIdentityList: 'NonHumanIdentity'
}
